import React from 'react'
import style from '../ReviewInfoBlock.module.scss'

const DiscussionButton = ({ scrollToBlock, translate }) => {
  return (
    <div>
      <button className={style.btn} onClick={scrollToBlock}>
        {translate.discussion}
      </button>
    </div>
  )
}

export default DiscussionButton
